var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { FormSettingsContext, addComponent, createStateSnapshot, defaultSettings, updateSettingsComponent, updateTabComponent, } from "./utils";
import copy from "fast-copy";
export var SettingsButtons = function (_a) {
    var layoutMeta = _a.layoutMeta, isDirty = _a.isDirty, layoutType = _a.layoutType;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var current = settings.currentComponent || {};
    var s = current.settings || {};
    var currentId = current.id || "";
    var currentComponent = current.component || {};
    var _c = useState(copy(layoutMeta)), saveTempLayout = _c[0], setTempLayout = _c[1];
    useEffect(function () {
        saveTempLayout &&
            saveTempLayout.length === 0 &&
            setTempLayout(copy(layoutMeta));
    }, [saveTempLayout && saveTempLayout]);
    // Annuler la mise à jour
    var revertSettingsUpdates = function () {
        editedSettings(__assign(__assign({}, defaultSettings), { clipBoard: settings.clipBoard, undoStack: settings.undoStack, redoStack: settings.redoStack, newLayout: saveTempLayout }));
    };
    useEffect(function () {
        settings.newLayout && setTempLayout(copy(settings.newLayout));
    }, [settings === null || settings === void 0 ? void 0 : settings.newLayout]);
    // Valider la mise à jour
    var commitSettingsUpdates = function () {
        var array = Object.values(settings.newLayout);
        var idToModify = settings.target;
        // Update layoutMeta
        var newUpdated = settings.newLayout.layout.components;
        //MAJ FLAG_CUSTOM FOR ETC-FIELD
        if (current.type === "etc-field") {
            current.settings = __assign(__assign({}, current.settings), { flag_custom: "1" });
        }
        newUpdated = updateSettingsComponent("components", "id", idToModify, array, settings);
        if (layoutType === "tab") {
            newUpdated = updateTabComponent(array, idToModify, settings.component && settings.component);
            editedSettings(__assign(__assign({}, settings), { parentId: {
                    id: settings.target,
                    type: settings.type,
                    components: currentComponent,
                }, selected: (current.components && currentId) || settings.target, isDirty: false, newLayout: { layout: newUpdated[0] } }));
        }
        // update layout
        editedSettings(__assign(__assign({}, settings), { isDirty: false, newLayout: { layout: newUpdated[0] } }));
    };
    // Pour ajouter un nouveau layout ou field
    var uuidv4 = require("uuid").v4;
    var id = uuidv4();
    var newComponentLayout = {
        id: id,
        type: layoutType,
        components: [],
        //settings: s,
        //add flag-custom pour new etc-field
        settings: layoutType === "etc-field"
            ? __assign(__assign({}, s), { flag_custom: "1" }) : s,
    };
    var addNewSettingsComponent = function () {
        var before = createStateSnapshot(copy(settings));
        var newC = addComponent(Object.values(settings.newLayout || []), settings.selected, newComponentLayout);
        var addState = __assign(__assign({}, settings), { selected: id, newLayout: { layout: newC[0] }, isNew: false });
        var after = createStateSnapshot(addState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "ADD_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, addState), { undoStack: saveUndo }));
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "flex items-center justify-center flex-none w-full" }, { children: [_jsx("button", __assign({ disabled: !isDirty, className: "button danger px-4 py-2 mr-4 rounded-md disabled:bg-[color:var(--color-brand-dark-400)] disabled:cursor-not-allowed", onClick: function (e) {
                        revertSettingsUpdates();
                    } }, { children: "Annuler" })), _jsx("button", __assign({ disabled: !isDirty, className: "button success px-4 py-2 rounded-md disabled:bg-[color:var(--color-brand-dark-400)] disabled:cursor-not-allowed", onClick: function (e) {
                        settings.isNew
                            ? addNewSettingsComponent()
                            : commitSettingsUpdates();
                    } }, { children: "Valider" }))] })) }));
};
